import React, { useState } from "react";
import styled from "styled-components";

import { Icon } from "components/Icon";


import { CheckPicker } from "rsuite";

const ShowColumnPicker = ({ columns, onChange, value, loading }) => {
    const [isOpen, setOpen] = useState(false);
    const pickerData = columns
        .filter(column => column.pickable !== false)
        .map(({ dataKey, label, fullLabel, name }) => ({
            dataKey,
            label: fullLabel || label || name
        }));

    return (
        <SelectorWrapper className="js-column-selector-wrapper">
            {!loading && <SelectorButton
                type="button"
                aria-label="Toggle column selector"
                onClick={() => setOpen(!isOpen)}
            >
                <Icon
                    className="columns-picker-icon-show"
                    icon={isOpen ? "indent" : "align-justify"}
                />
            </SelectorButton>}
            <CheckPicker
                className="position-absolute z-index-dropdown invisible"
                open={isOpen && !loading}
                valueKey="dataKey"
                value={value}
                data={pickerData}
                // menuAutoWidth={false}
                searchable={false}
                onChange={onChange}
                onClose={() => setOpen(false)}
                style={{ width: 190 }}
                menuStyle={{ width: 280 }}
            // disabled
            // loading
            />
        </SelectorWrapper>
    );
};

export default ShowColumnPicker;

const SelectorWrapper = styled.div`
    align-items: center;
    display: inline-flex;
    justify-content: center;
    left: 4px;
    margin: 0;
    min-height: 24px;
    position: absolute;
    top: 8px;
    z-index: 5;
`;

const SelectorButton = styled.button`
    align-items: center;
    background: transparent;
    border: 0;
    color: #fff;
    cursor: pointer;
    display: inline-flex;
    height: 24px;
    justify-content: center;
    padding: 0;
    width: 24px;

    &:focus {
        outline: none;
    }

    .columns-picker-icon-show {
        color: currentColor;
        font-size: 18px;
        line-height: 1;
        padding: 0;
    }
`;
